import { toast } from 'react-toastify';

export const showToast = (type, message, position = "top-center") => {
    if (!message) return;

    const options = {
        position,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "light",
    };

    switch (type) {
        case 'success':
            toast.success(message, options);
            break;
        case 'error':
            toast.error(message, options);
            break;
        case 'info':
            toast.info(message, options);
            break;
        case 'warn':
        case 'warning':
            toast.warn(message, options);
            break;
        default:
            toast(message, options);
    }
};
